export default "__VITE_PUBLIC_ASSET__8fffa324__"